const BASE_URL = "/api"
const DEV_HOST = "http://n0rt0n31337.fvds.ru/"
const STORAGE_URL = "/storage"

const fetchUnreadsInterval = 60 * 1000
const defaultPage = 0

export const CONFIG = {
  DEV_HOST,
  BASE_URL,
  STORAGE_URL,
  fetchUnreadsInterval,
  defaultPage
}
